

































































import { Component, Mixins } from "vue-property-decorator";
import { AdcontrolProfile, User } from "@/models";
import { Getter, Action } from "vuex-class";
import { AgentModuleConfiguration } from "@/models";
import AgentModuleConfigurationMixin, {
  AgentModuleConfigurationMixinTags,
} from "@/mixins/http/Agencies/AgentModuleConfigurationMixin";
import { FEATURE_AGENTS_MATCH_PROBLEM } from "@/constants";
import { MissingPrincipalProductRecord } from "@/models/Agents/Product";
import MatchConflictsProductSelectPrincipalAccordion from "@/components/Agents/MatchConflictsProductSelectPrincipalAccordion.vue";
import ToastInvoker from "@/utils/ToastInvoker";
import ColorHelper from "@/services/ColorHelper";
import MessagePanel from "@/components/MessagePanel.vue";
import NotificationBadge, {
  NotificationBadgeGroups,
} from "@/components/Agents/NotificationBadge.vue";
import AgentsMatchProblemGroupMixin, {
  AgentsMatchProblemGroupMixinTags,
} from "@/mixins/http/Agents/AgentsMatchProblemGroupMixin";
import MatchProblemGroup from "@/models/Agents/MatchProblemGroup";

@Component({
  components: {
    MessagePanel,
    NotificationBadge,
    MatchConflictsProductSelectPrincipalAccordion,
  },
})
export default class ConflictsRegistry extends Mixins(
  AgentModuleConfigurationMixin,
  AgentsMatchProblemGroupMixin
) {
  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Getter("user") readonly user!: User;

  @Action("notificationsGroups/valorizeMatchProblems")
  readonly valorizeMatchProblemsNotifications!: (
    notificationCount: number
  ) => void;

  missingPrincipals: string[] = [];
  productsWithMissingPrincipals: MissingPrincipalProductRecord[] = [];
  agentModuleConfiguration: AgentModuleConfiguration | null = null;
  matchProblemsGroups: MatchProblemGroup[] = [];
  multipleProductsGroupsNames: string[] = [];
  conflictsRegistryNotificationGroup: NotificationBadgeGroups[] = [
    NotificationBadgeGroups.MatchProblem,
  ];

  async mounted() {
    await this.valorizeMatchProblems();
    await this.valorizeAgentModuleConfiguration();
  }

  get loading(): boolean {
    const matchProblemLoading =
      this.$store.getters["http/status"][
        AgentsMatchProblemGroupMixinTags.GetMatchProblems
      ]?.loading ?? false;

    const agentModuleConfigurationLoading =
      this.$store.getters["http/status"][
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration
      ]?.loading ?? false;

    return matchProblemLoading || agentModuleConfigurationLoading;
  }

  async valorizeMatchProblems() {
    if (!this.hasMatchProblem) {
      return;
    }

    try {
      this.matchProblemsGroups = [];
      this.matchProblemsGroups = await this.getMatchProblemsGroups(
        AgentsMatchProblemGroupMixinTags.GetMatchProblems,
        this.profile.slug
      )
        .then((results) =>
          results.sort(
            (a, b) =>
              a.adcontrolProductName.localeCompare(b.adcontrolProductName) // alphabetical sort
          )
        )
        .then((results) =>
          results.map<MatchProblemGroup>((group) => {
            group.adcontrolCompanyIconColor = ColorHelper.pick();
            return group;
          })
        );

      this.valorizeMatchProblemsNotifications(this.matchProblemsGroups.length);
    } catch (_e) {
      ToastInvoker.errorToast("Errore nel caricamento", _e);
      this.matchProblemsGroups = [];
    }
  }

  async valorizeAgentModuleConfiguration() {
    try {
      this.agentModuleConfiguration = await this.getAgentModuleConfiguration(
        AgentModuleConfigurationMixinTags.GetAgentModuleConfiguration,
        this.profile.slug
      );
    } catch (_e) {
      this.agentModuleConfiguration = null;
    }
  }

  get hasMatchProblem() {
    return this.user.profile?.hasFeature(FEATURE_AGENTS_MATCH_PROBLEM) ?? false;
  }
}
